export function signin(data) {
  return {
    type: "SAGA_LOGIN",
    data
  };
}

export function signUp(data) {
  return {
    type: "SAGA_SIGNUP",
    data
  };
}

export function signout() {
  return {
    type: "SIGNOUT"
  };
}



// WEBPACK FOOTER //
// ./src/actions/auth.js